
import { Label } from '@/components/ui/label';

interface FileListProps {
  attachments: string[];
}

export function FileList({ attachments }: FileListProps) {
  return (
    <div className="space-y-2">
      <Label>Existing Attachments</Label>
      <div className="space-y-1">
        {attachments.map((url, index) => (
          <div key={index} className="flex items-center gap-2 text-sm">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              Attachment {index + 1}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
